/**
 * Synchronous in-flight lock for concierge sends.
 *
 * React state (`status === 'submitted'`) is too late to stop a second click
 * ~50ms later. A lock taken in the same tick is the guard.
 *
 * `cancel()` is for Stop: drop the lock immediately so the shopper can send
 * again before the aborted fetch's `finally` runs. `end(token)` is a no-op if
 * a newer send already owns the lock.
 */
export type InFlightSendLock = {
  tryBegin: () => number | null;
  end: (token: number) => void;
  cancel: () => void;
  isInFlight: () => boolean;
};

export function createInFlightSendLock(): InFlightSendLock {
  let token = 0;
  let inFlight = false;

  return {
    tryBegin() {
      if (inFlight) return null;
      inFlight = true;
      token += 1;
      return token;
    },
    end(begunToken: number) {
      if (token === begunToken) inFlight = false;
    },
    cancel() {
      token += 1;
      inFlight = false;
    },
    isInFlight: () => inFlight,
  };
}
